// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"TopBarMenu_popoverContainer__3LF4B","menu":"TopBarMenu_menu__2jQ9_"};